// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__g70LN","fullScreenWrapper":"style_fullScreenWrapper__JD4jM"};